import { useEffect, useState } from 'react';
import { NetworkStatus } from '../../types/NetworkStatus';
import { cn } from '../../lib/utils';
import { Text } from '../typography/typography';
import { Icon } from '../icon/icon';

export function NetworkStatusBanner({ status }: { status: NetworkStatus }) {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (status === 'offline') {
      setShouldRender(true);
      // Small delay to ensure the element is in the DOM before animating
      requestAnimationFrame(() => {
        setIsVisible(true);
      });
    } else {
      setIsVisible(false);
      // Wait for animation to complete before removing from DOM
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [status]);

  if (!shouldRender) return null;

  return (
    <div
      className={cn(
        'fixed bottom-2 left-1/2 z-[9999] -translate-x-1/2 transition-all duration-300 ease-in-out',
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-8 opacity-0',
      )}
    >
      <div className="flex items-center gap-2 rounded-full bg-red-500/50 px-6 py-2 text-red-900 shadow-sm backdrop-blur-lg dark:bg-red-500/50">
        <Icon
          icon="lucide:wifi-off"
          className="h-4 w-4 text-black dark:text-white"
        />
        <Text size="sm" className="text-black dark:text-white">
          Connection lost – reconnecting...
        </Text>
      </div>
    </div>
  );
}
